import { ReactNode } from 'react';

import { generateUniqueId } from './../../../../../../helpers/uniqueIdGenerator';

export const ICloseDialogActionALL = null
export type ICloseDialogAction = { type: 'CLOSE_DIALOG', id: string | null }

export const closeDialog = (id: string|null = null) => ({
  type: 'CLOSE_DIALOG',
  id
})

export const openDialog = (content: ((() => ReactNode)|ReactNode), id: string|null = null, maxWidth: string = 'sm') => ({
  type: 'OPEN_DIALOG',
  id: id || generateUniqueId(),
  maxWidth,
  content
})